module.exports = __webpack_public_path__ + "img/emoji_92.4bf2106d.png";